import React, { useState, useEffect } from 'react';

interface ConnectionStatusProps {
  isConnected: boolean;
  message?: string;
  username?: string;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  isConnected,
  message,
  username
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [hideTimeout, setHideTimeout] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Bağlandığında 3 saniye sonra gizle
    if (isConnected) {
      const timeout = setTimeout(() => {
        setIsVisible(false);
      }, 3000);
      setHideTimeout(timeout);
    } else {
      // Bağlantı koptuğunda tekrar göster
      setIsVisible(true);
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        setHideTimeout(null);
      }
    }

    // Cleanup
    return () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
    };
  }, [isConnected]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
    };
  }, [hideTimeout]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div
        className={`
          px-3 py-2 rounded-lg text-sm font-medium backdrop-blur-md border
          transition-all duration-300
          ${isConnected 
            ? 'bg-emerald-900/80 text-emerald-200 border-emerald-500/50' 
            : 'bg-slate-900/80 text-slate-300 border-slate-600/50'
          }
        `}
      >
        <div className="flex items-center gap-2">
          {/* Durum ikonu */}
          <div
            className={`
              w-2 h-2 rounded-full transition-colors duration-300
              ${isConnected ? 'bg-emerald-400' : 'bg-slate-500'}
            `}
          />
          
          {/* Kullanıcı adı */}
          {username && (
            <span className="font-semibold">
              {username}
            </span>
          )}
          
          {/* Durum mesajı */}
          <span className="text-xs">
            {message || (isConnected ? 'Bağlı' : 'Bağlantı yok')}
          </span>
        </div>
      </div>
    </div>
  );
};
